import React from 'react';

import Chip from '~/components/core/Atomic/Chip/Chip';
import cn from '~/Utils/cn';

// Says where a field or configuration came from (CONFIGURED, CUSTOM): a pale teal chip, its border a lighter shade
// of its text. A configuration's scope chip (CUSTOM, DEFAULT) has square corners, like the Reset to Default button
// beside it, and DEFAULT takes that button's primary color.
type ClaimBarPillProps = {
  label: string;
  scope?: 'custom' | 'default';
};

const ClaimBarPill = ({ label, scope }: ClaimBarPillProps) => (
  <Chip
    label={label}
    size="small"
    variant="outlined"
    color={scope === 'default' ? 'primary' : 'default'}
    className={cn('m-0 font-medium uppercase', {
      rounded: scope !== undefined,
      'border-teal-300 bg-teal-100 text-teal-800': scope !== 'default',
      'border-blue-600/50': scope === 'default',
    })}
  />
);

export default ClaimBarPill;
